<template>
  <div>
    <p>mobile</p>
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style></style>
